// Small formatting + date helpers for the prototype (GEL currency, Tbilisi clinic).

import { formatDateValue, formatMoneyValue, formatRelativeTimeValue, getRuntimeLanguage } from "@/i18n/core";

export const GEL = "\u20BE";

export function money(n, language = getRuntimeLanguage()) {
  return formatMoneyValue(n, language);
}

export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => {
      const initial = part[0] || "";
      // Georgian has no case in normal Mkhedruli UI text. `toUpperCase()` turns
      // it into Mtavruli, which reads like display capitals rather than natural
      // avatar initials. Latin (and other cased scripts) still use capitals.
      return /[\u10D0-\u10FF]/u.test(initial) ? initial : initial.toUpperCase();
    })
    .join("");
}

const DAY = 24 * 60 * 60 * 1000;

export function startOfDay(d = new Date()) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function startOfWeek(d = new Date()) {
  // Monday as first day
  const x = startOfDay(d);
  const day = (x.getDay() + 6) % 7;
  return new Date(x.getTime() - day * DAY);
}

export function addDays(d, n) {
  return new Date(new Date(d).getTime() + n * DAY);
}

// Build a Date at a given day-offset from today + decimal hour (e.g. 10.5 = 10:30)
export function at(dayOffset, hour) {
  const d = startOfDay(new Date());
  d.setDate(d.getDate() + dayOffset);
  const h = Math.floor(hour);
  const m = Math.round((hour - h) * 60);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
}

export function fmtTime(iso, language = getRuntimeLanguage()) {
  return formatDateValue(iso, language, { hour: "2-digit", minute: "2-digit" });
}

export function fmtDay(iso, language = getRuntimeLanguage()) {
  return formatDateValue(iso, language, { weekday: "short", day: "numeric", month: "short" });
}

export function fmtDayLong(iso, language = getRuntimeLanguage()) {
  return formatDateValue(iso, language, { weekday: "long", day: "numeric", month: "long" });
}

export function timeAgo(iso, language = getRuntimeLanguage()) {
  return formatRelativeTimeValue(iso, language);
}

export function decimalHour(iso) {
  const d = new Date(iso);
  return d.getHours() + d.getMinutes() / 60;
}

export function sameDay(a, b) {
  const x = new Date(a);
  const y = new Date(b);
  return x.toDateString() === y.toDateString();
}

export function uid(prefix = "id") {
  return `${prefix}-${Math.random().toString(36).slice(2, 8)}`;
}
